import types from './types';
import { combineReducers } from 'redux';
import _ from 'lodash';


const connected = (state = [], action) => {
  switch (action.type) {
    case types.MQTT_CONNECT:
    case types.MQTT_RECONNECT:
      return true;
    case types.MQTT_DISCONNECT:
    case types.MQTT_ERROR:
      return false;
    default:
      return state;
  }
};


const error = (state = false, action) => {
  switch (action.type) {
    case types.MQTT_ERROR:
      return action.error;
    case types.MQTT_CONNECT:
    case types.MQTT_RECONNECT:
    case types.MQTT_DISCONNECT:
        return false;
    default:
      return state;
  }
};

export default combineReducers({
  connected,
  error
});

// devices: {
//   byId: {

//   }
//   allIds: ["JOTO_1231231", "JOTO_1231231"]
//   selected: "JOTO_1231231"
// }

// shadows: {
//   byId: {

//   }
//   allIds: ["JOTO_1231231", "JOTO_1231231"]
// }

// FROM A SELECTOR:

// JOTO_1231231: {
//   jot:
//   draftJot: ""
//   status: "idle"
//   connected: false
//   ping: 123,
//   firmware:
// }

// const original = {
//   foo: 'bar',
//   stack: 'overflow',
// };

// // If the name of the property to remove is constant
// const { stack, ...withoutFirst } = original;
// console.log(withoutFirst); // Will be { "foo": "bar" }

// const { [id]: state[id], ...newState } = state;
// console.log(newState); // Will be { "foo": "bar" }

// // To do a deep removal with property names from variables
// const deep = {
//   foo: 'bar',
//   c: {
//    x: 1,
//    y: 2
//   }
// };

// const parentKey = 'c';
// const childKey = 'y';
// // Remove the 'c' element from original
// const { [parentKey]: parentValue, ...noChild } = deep;
// // Remove the 'y' from the 'c' element
// const { [childKey]: removedValue, ...childWithout } = parentValue;
// // Merge back together
// const withoutThird = { ...noChild, [parentKey]: childWithout };
// console.log(withoutThird); // Will be { "foo": "bar", "c": { "x": 1 } }
